import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/home/block2-背景装饰-椭圆.png")